/* eslint-disable no-case-declarations */
/* eslint-disable no-unsafe-optional-chaining */
import AurDataGrid from '../../common/aur-data-grid/AurDataGrid';
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from 'react';
import AurSelectDropdown from '../../common/aur-select-dropdown/AurSelectDropdown';
import {t} from 'i18next';
import {Box, Typography} from '@mui/material';
import AurDateRangePicker from '../../common/aur-date-range-picker/AurDateRangePicker';
import {getHighLevelProductionMetricTableColumns} from '../../../utils/highLevelProductionMetricUtils';
import AurChipList, {AurChipConfig} from '../../common/aur-chip/AurChipList';
import AurIcon, {IconColors, IconNames} from '../../common/aur-icon/AurIcon';
import {setChartData} from '../../../redux/slices/highLevelProductionMetricSlice';
import {useDispatch, useSelector} from 'react-redux';
import {
  convertDateStringToObject,
  generateNOpenPDF,
  getLocalFormatedDate,
  IArrayData,
  numberFormatter,
  removeEmptyArrays,
} from '../../../utils/utils';
import {RootState} from '../../../redux/store';
import {GridSortModel} from '@mui/x-data-grid';
import {
  clearFilters,
  fecthHighlevelIntakeTableData,
  fecthProductionNameData,
  getSavedFilters,
  saveFilters,
} from '../../../api/ReportingManagement';
import AurPopup from '../../common/aur-popup/AurPopup';
import AurLoadingIndicator from '../../common/aur-loading-indicator/AurLoadingIndictor';
import html2canvas from 'html2canvas';
import {Grid} from '@mui/material';
import AurDocPiechart from '../../common/aur-docpiechart/AurDocPiechart';
import {
  CUSTOM_REPORT_COL_HEIGHT,
  failedToLoadStatusCodes,
  INVOICE_REPORT_GRID_ERROR_COMPONENT,
} from '../../../constants/constants';
import AurDataGridErrorOverlay from '../../common/aur-data-grid-error-overlay/AurDataGridErrorOverlay';
import AurDataGridLoadingOverlay from '../../common/aur-data-grid-loading-overlay/AurDataGridLoadingOverlay';
import {TABLE_PAGE_SIZE_OPTION} from '../../../constants/constants';
import {debounce} from 'lodash';
import {
  GA_CLICK_TYPES,
  GA_EVENT_NAMES,
  GA_REGIONS,
} from '../../../constants/analyticsConstants';
import {useAnalytics} from '../../../hooks/useAnalytics';

const colors = ['#00D0DB', '#6E87FF'];

const bgColor = '#0c1119';
const DEBOUNCE_DELAY = 300;

export interface HighLevelProductionMetricTableHandles {
  downloadNExportReport: () => void;
}

const HighLevelProductionMetricTable =
  forwardRef<HighLevelProductionMetricTableHandles>((props, ref) => {
    //Handle error when api fails
    const tableContainerRef = useRef<HTMLDivElement | null>(null);
    const [size, setSize] = useState(
      (tableContainerRef.current?.offsetHeight ?? 500) +
        INVOICE_REPORT_GRID_ERROR_COMPONENT
    );

    const [isFailedToLoadProductionMetric, setIsFailedToLoadProductionMetric] =
      useState<boolean>(false);
    const dispatch = useDispatch();
    const {trackGAEvent} = useAnalytics();
    const parentElementRef = useRef<HTMLDivElement | null>(null);
    const chartRef = useRef(null);
    const [productionData, setProductionData] = useState<any>([]);
    const [startDate, setStartDate] = useState(
      getLocalFormatedDate(
        new Date(new Date().setFullYear(new Date().getFullYear() - 5))
      )
    );
    const [endDate, setEndDate] = useState(getLocalFormatedDate(new Date()));
    const clientId = useSelector((state: RootState) => state.reports)?.clientId;
    const projectId = useSelector(
      (state: RootState) => state.reports?.projectId
    );
    const workSpaceId = useSelector(
      (state: RootState) => state.reports?.workspaceId
    );
    const reportId = 7;
    const onSetSortModel = (sortModel: GridSortModel) => {
      setSortModel(sortModel);
    };
    const handleOnDateChange = (start: string, end: string) => {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.FILTER,
        click: {
          name: t('gaTracking.reports.selectDateRange'),
          type: GA_CLICK_TYPES.DROPDOWN,
          region: GA_REGIONS.BODY,
          action: t('gaTracking.reports.filterReport'),
        },
      });
      const startDate = getLocalFormatedDate(start);
      setStartDate(startDate);
      const endDate = getLocalFormatedDate(end);
      setEndDate(endDate);
      setHasFilterValueChanged(true);
      setChipsConfig((prevConfig) =>
        prevConfig.map((filter) =>
          filter.id === 1
            ? {
                ...filter,
                filterSelection:
                  filter.filterSelection.length > 0
                    ? filter.filterSelection.map((selection) =>
                        selection.id === 1
                          ? {
                              ...selection,
                              value:
                                getLocalFormatedDate(startDate) ===
                                getLocalFormatedDate(endDate)
                                  ? `${getLocalFormatedDate(startDate)}`
                                  : `${getLocalFormatedDate(startDate)} -- ${getLocalFormatedDate(endDate)}`,
                            }
                          : selection
                      )
                    : [
                        {
                          id: 1,
                          value:
                            getLocalFormatedDate(startDate) ===
                            getLocalFormatedDate(endDate)
                              ? `${getLocalFormatedDate(startDate)}`
                              : `${getLocalFormatedDate(startDate)} -- ${getLocalFormatedDate(endDate)}`,
                        },
                      ],
              }
            : filter
        )
      );
    };
    const [productionName, setProductionName] = useState<string[]>([]);
    const [exportPdf, setExportPdf] = useState<boolean>(false);
    const [selectedRows, setSelectedRows] = useState<number | null>(null);
    const [hasFilterValueChanged, setHasFilterValueChanged] = useState(true);
    const [searchKeyword] = useState<string>('');
    const [sortModel, setSortModel] = useState<GridSortModel>([]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [itemsPerPage, setItemsPerPage] = useState<number>(25);
    const [tableData, setTableData] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>([]);
    const [resetToDefaultModal, setResetToDefaultModal] =
      useState<boolean>(false);
    const [clearAllModal, setClearAllModal] = useState<boolean>(false);
    const [isFetchProductionMetricLoading, setIsFetchProductionMetricLoading] =
      useState(false);
    const [isFetchProductionDataLoading, setIsFetchProductionDataLoading] =
      useState(false);
    const [isFetchSavedFiltersLoading, setIsFetchSavedFiltersLoading] =
      useState(false);
    const [isOnSaveFilterLoading, setIsOnSaveFilterLoading] = useState(false);
    const [isClearAllFilterLoading, setIsClearAllFilterLoading] =
      useState(false);
    const {chartData} = useSelector(
      (state: RootState) => state.productionMetric
    );
    const data = [
      {name: 'Produced Natively', y: chartData.nativeCount, type: 'native'},
      {name: 'Produced as Images', y: chartData.imageCount, type: 'images'},
    ];
    const [chipConfigs, setChipsConfig] = useState<AurChipConfig[]>([
      {
        id: 1,
        filterName: t('filter.dateReceived'),
        filterSelection: [],
        showRemove: true,
        onRemove: () => onRemoveFilter(1),
      },
      {
        id: 2,
        icon: (
          <AurIcon
            size="small"
            icon={IconNames.Search}
            color={IconColors.Custom}
            customClassName="chip-filter-name-icon"
          />
        ),
        filterName: t('filter.productionName'),
        filterSelection: [],
        showRemove: true,
        onRemove: () => onRemoveFilter(2),
      },
    ]);

    const handleOnSave = (config?: AurChipConfig[]) => {
      console.log('onsave clicked', config);
      onSaveFilters();
    };

    const getSelectedFilters = () => {
      const result: IArrayData = {
        custodians: [],
        productionNames: [
          ...(chipConfigs?.[1]?.filterSelection ?? []).map(
            (item) => item.value
          ),
        ],
        receivedDate: {
          fromDate: getLocalFormatedDate(startDate),
          toDate: getLocalFormatedDate(endDate),
        },
      };
      chipConfigs.forEach((chipConfig) => {
        switch (chipConfig.filterName) {
          case 'Production Name':
            result.productionNames = (chipConfig.filterSelection ?? []).map(
              (item) => item.value.toString()
            );
            break;
          case 'Date Received':
            if ((chipConfig?.filterSelection ?? []).length > 0) {
              const fromDate =
                chipConfig?.filterSelection?.[0]?.value?.split(' -- ')?.[0];
              const toDate =
                chipConfig?.filterSelection?.[0]?.value?.split(' -- ')?.[1];
              result.receivedDate = {
                fromDate,
                toDate,
              };
            } else if (result.receivedDate) {
              delete result.receivedDate;
            }
            break;
          default:
            break;
        }
      });
      return removeEmptyArrays(result);
    };
    const onSaveFilters = async () => {
      setIsOnSaveFilterLoading(true);
      try {
        const paramString = `?clientId=${clientId}&projectId=${projectId}&workspaceId=${workSpaceId}`;
        const requestBody = getSelectedFilters();
        await saveFilters(reportId, paramString, requestBody);
        const savedFilters = requestBody as any;
        const tempData = savedFilters?.productionNames?.map((item: any) => {
          return {
            value: item,
          };
        });

        setProductionName(tempData ?? []);
        setChipsConfig([
          {
            ...chipConfigs[0],
            filterSelection:
              savedFilters?.receivedDate?.fromDate &&
              savedFilters?.receivedDate?.toDate
                ? [
                    {
                      id: 1,
                      value:
                        getLocalFormatedDate(
                          savedFilters.receivedDate.fromDate
                        ) ===
                        getLocalFormatedDate(savedFilters.receivedDate.toDate)
                          ? `${getLocalFormatedDate(savedFilters.receivedDate.fromDate)}`
                          : `${getLocalFormatedDate(savedFilters.receivedDate.fromDate)} -- ${getLocalFormatedDate(savedFilters.receivedDate.toDate)}`,
                    },
                  ]
                : [],
          },
          {...chipConfigs[1], filterSelection: tempData},
        ]);
        setStartDate(
          getLocalFormatedDate(
            savedFilters?.receivedDate?.fromDate ??
              new Date(new Date().setFullYear(new Date().getFullYear() - 5))
          )
        );
        setEndDate(
          getLocalFormatedDate(savedFilters?.receivedDate?.toDate ?? new Date())
        );
        setHasFilterValueChanged(false);
      } catch (error) {
        console.error('Failed to save filters:', error);
      } finally {
        setIsOnSaveFilterLoading(false);
      }
    };
    const handleResetToDefault = () => {
      setResetToDefaultModal(true);
    };
    const handleOnClearAll = () => {
      setClearAllModal(true);
    };
    const closeModalHandler = () => {
      setClearAllModal(false);
      setResetToDefaultModal(false);
    };
    const handleResetToDefaultModalOptionSelected = () => {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.FILTER,
        click: {
          name: t('gaTracking.global.resetToDefault'),
          type: GA_CLICK_TYPES.BUTTON,
          region: GA_REGIONS.BODY,
          action: t('gaTracking.reports.filterReport'),
        },
      });
      closeModalHandler();
      onclearFilter();
    };
    const handleClearAllModalOptionSelected = () => {
      trackGAEvent({
        eventName: GA_EVENT_NAMES.FILTER,
        click: {
          name: t('gaTracking.global.clearAll'),
          type: GA_CLICK_TYPES.BUTTON,
          region: GA_REGIONS.BODY,
          action: t('gaTracking.reports.filterReport'),
        },
      });
      closeModalHandler();
      setChipsConfig((prevConfig) =>
        prevConfig.map((filter) => ({...filter, filterSelection: []}))
      );
      setStartDate(
        getLocalFormatedDate(
          new Date(new Date().setFullYear(new Date().getFullYear() - 5))
        )
      );
      setEndDate(getLocalFormatedDate(new Date()));
      setChipsConfig([
        {...chipConfigs[0], filterSelection: []},
        {...chipConfigs[1], filterSelection: []},
      ]);
    };
    const handleOnDropdownDataChanged = (id: number, filterData: any) => {
      if (
        JSON.stringify(chipConfigs[id].filterSelection) ===
        JSON.stringify(filterData)
      ) {
        return; // Avoid redundant state updates
      }
      setProductionName(filterData.map((item: any) => item.name));
      setChipsConfig((prevState) => {
        return prevState.map((config, index) =>
          index === id ? {...config, filterSelection: filterData} : config
        );
      });
      setHasFilterValueChanged(true);
    };
    const onRemoveFilter = (filterId: number) => {
      setHasFilterValueChanged(true);
      setChipsConfig((prevConfig) =>
        prevConfig.map((filter) =>
          filter.id === filterId ? {...filter, filterSelection: []} : filter
        )
      );
      if (filterId === 1) {
        setStartDate(
          getLocalFormatedDate(
            new Date(new Date().setFullYear(new Date().getFullYear() - 5))
          )
        );
        setEndDate(getLocalFormatedDate(new Date()));
      }
      filterId === 2 && setProductionName([]);
    };

    const onclearFilter = async () => {
      setIsClearAllFilterLoading(true);

      try {
        let paramString = '?';

        if (clientId != '' && projectId != '' && workSpaceId != '') {
          paramString =
            paramString +
            `clientId=${clientId}&projectId=${projectId}&workspaceId=${workSpaceId}&`;
        }
        const result = await clearFilters(reportId, paramString);
        if (result?.status == 200) {
          setProductionName([]);
          setStartDate(
            getLocalFormatedDate(
              new Date(new Date().setFullYear(new Date().getFullYear() - 5))
            )
          );
          setEndDate(getLocalFormatedDate(new Date()));
          setChipsConfig([
            {...chipConfigs[0], filterSelection: []},
            {...chipConfigs[1], filterSelection: []},
          ]);
        }
      } catch (error) {
        console.error('Failed to clear filters:', error);
      } finally {
        setIsClearAllFilterLoading(false);
      }
    };
    const fetchSavedFilters = async () => {
      setIsFetchSavedFiltersLoading(true);
      try {
        let paramString = '?';

        if (clientId != '' && projectId != '' && workSpaceId != '') {
          paramString =
            paramString +
            `clientId=${clientId}&projectId=${projectId}&workspaceId=${workSpaceId}&reportId=${reportId}&`;
        }

        paramString =
          paramString +
          `search=${searchKeyword}&pageNumber=${currentPage}&pageSize=${itemsPerPage}`;

        const result = await getSavedFilters(paramString);
        const tempData = result?.data?.data?.productionNames?.map(
          (item: any) => {
            return {
              value: item,
            };
          }
        );

        setProductionName(tempData ?? []);

        setChipsConfig([
          {
            ...chipConfigs[0],
            filterSelection:
              result?.data?.data?.receivedDate?.fromDate &&
              result?.data?.data?.receivedDate?.toDate
                ? [
                    {
                      id: 1,
                      value:
                        getLocalFormatedDate(
                          result?.data?.data.receivedDate.fromDate
                        ) ===
                        getLocalFormatedDate(
                          result?.data?.data.receivedDate.toDate
                        )
                          ? `${getLocalFormatedDate(result?.data?.data.receivedDate.fromDate)}`
                          : `${getLocalFormatedDate(result?.data?.data.receivedDate.fromDate)} -- ${getLocalFormatedDate(result?.data?.data.receivedDate.toDate)}`,
                    },
                  ]
                : [],
          },
          {...chipConfigs[1], filterSelection: tempData},
        ]);
        setStartDate(
          getLocalFormatedDate(
            result?.data?.data.receivedDate?.fromDate ??
              new Date(new Date().setFullYear(new Date().getFullYear() - 5))
          )
        );
        setEndDate(
          getLocalFormatedDate(
            result?.data?.data.receivedDate?.toDate ?? new Date()
          )
        );
        setHasFilterValueChanged(false);
      } catch (error: any) {
        {
          // setIsFailedToLoadProductionMetric(true);
        }
      } finally {
        setIsFetchSavedFiltersLoading(false);
      }
    };
    const fetchProductMetric = async () => {
      setIsFetchProductionMetricLoading(true);
      try {
        setIsFailedToLoadProductionMetric(false);
        let paramString = '?';

        if (clientId != '' && projectId != '' && workSpaceId != '') {
          paramString =
            paramString +
            `clientId=${clientId}&projectId=${projectId}&workspaceId=${workSpaceId}&`;
        }

        const productNameSelection = chipConfigs?.[1]?.filterSelection
          ? chipConfigs[1].filterSelection.map((item) => item.value)
          : [];
        paramString += `&productName=${productNameSelection}&fromDate=${getLocalFormatedDate(startDate)}&toDate=${getLocalFormatedDate(endDate)}&SearchTerm=${searchKeyword}&SortColumn=${sortModel[0]?.field?.toLowerCase() || ''}&SortOrder=${sortModel[0]?.sort}&pageNumber=${currentPage}&pageSize=${itemsPerPage}`;

        const result = await fecthHighlevelIntakeTableData(paramString);
        setTableData(result?.data);
        setPaginationData(result?.meta?.pagination);
      } catch (error: any) {
        if (failedToLoadStatusCodes.includes(error.status))
          setIsFailedToLoadProductionMetric(true);
        setIsFetchProductionDataLoading(false);
      } finally {
        setIsFetchProductionMetricLoading(false);
      }
    };

    const fetchProductionData = async () => {
      try {
        setIsFetchProductionDataLoading(true);
        let paramString = '?';

        if (clientId != '' && projectId != '' && workSpaceId != '') {
          paramString =
            paramString +
            `clientId=${clientId}&projectId=${projectId}&workspaceId=${workSpaceId}&`;
        }
        const result = await fecthProductionNameData(paramString);
        const tempData = result?.data?.map((ele: any) => {
          return {
            name: ele.productionNames,
          };
        });
        setProductionData(tempData);
      } catch (error: any) {
        if (failedToLoadStatusCodes.includes(error.status))
          setIsFetchProductionDataLoading(false);
      } finally {
        setIsFetchProductionDataLoading(false);
      }
    };

    const debouncedFetchProductionData = useCallback(
      debounce(() => {
        setTableData([]);
        fetchProductMetric(); //fetch the table data
        fetchProductionData(); //fetch the dropDown data
      }, DEBOUNCE_DELAY),
      [chipConfigs, sortModel, currentPage]
    );

    useEffect(() => {
      debouncedFetchProductionData();
      return () => {
        debouncedFetchProductionData.cancel();
      };
    }, [chipConfigs, sortModel, currentPage]);

    useEffect(() => {
      fetchSavedFilters();
    }, [clientId, projectId, workSpaceId, reportId, sortModel]);

    useEffect(() => {
      const productionSets = paginationData?.totalItems ?? 0;
      const firstBates = tableData[0]?.firstBates;
      const lastBates = tableData[tableData.length - 1]?.lastBates;
      const imageCount = tableData.reduce(
        (accumulator: any, currentObject: any) => {
          return accumulator + (currentObject.imageCount ?? 0);
        },
        0
      );
      const nativeCount = tableData.reduce(
        (accumulator: any, currentObject: any) => {
          return accumulator + (currentObject.nativeCount ?? 0);
        },
        0
      );
      const payload = {
        productionSets: productionSets,
        firstBates: firstBates,
        lastBates: lastBates,
        imageCount: imageCount,
        nativeCount: nativeCount,
      };
      dispatch(setChartData(payload));
    }, [tableData]);

    const handleRowClick = (row: any) => {
      setSelectedRows((prevSelectedRows) => {
        const isRowSelected = prevSelectedRows === row.id;

        const productionSets = paginationData?.totalItems ?? 0;
        const firstBates = tableData[0]?.firstBates;
        const lastBates = tableData[productionSets - 1]?.lastBates;
        const imageCount = tableData.reduce(
          (accumulator: any, currentObject: any) => {
            return accumulator + (currentObject.imageCount ?? 0);
          },
          0
        );
        const nativeCount = tableData.reduce(
          (accumulator: any, currentObject: any) => {
            return accumulator + (currentObject.nativeCount ?? 0);
          },
          0
        );
        const payload = isRowSelected
          ? {
              productionSets: productionSets,
              firstBates: firstBates,
              lastBates: lastBates,
              imageCount: imageCount,
              nativeCount: nativeCount,
            }
          : {
              productionSets: productionSets,
              firstBates: row.firstBates,
              lastBates: row.lastBates,
              imageCount: row.imageCount,
              nativeCount: row.nativeCount,
            };

        dispatch(setChartData(payload));
        return isRowSelected ? null : row.id;
      });
    };

    const downloadNExportReport = useCallback(() => {
      if (parentElementRef?.current) {
        setExportPdf(true);
        html2canvas(parentElementRef?.current, {scale: 1})
          .then((canvas) => {
            const imgData = canvas.toDataURL('image/jpeg');
            const formattedDate = Date.now();
            generateNOpenPDF(
              imgData,
              canvas,
              `${workSpaceId}_${formattedDate}`
            );

            const chartElement = chartRef?.current;
            if (chartElement) {
              return html2canvas(chartElement, {scale: 1});
            }

            return Promise.reject('Chart element not found');
          })

          .catch((error) => {
            console.error('Error capturing chart:', error);
          })
          .finally(() => {
            setExportPdf(false);
          });
      }
    }, []);

    useImperativeHandle(ref, () => ({
      downloadNExportReport,
    }));

    /**
     * To get datagrid height
     */
    useEffect(() => {
      const updateHeight = () => {
        if (tableContainerRef.current) {
          setSize(
            tableContainerRef.current.offsetHeight - CUSTOM_REPORT_COL_HEIGHT
          );
        }
      };
      window.addEventListener('resize', updateHeight);
      updateHeight();

      return () => window.removeEventListener('resize', updateHeight);
    });
    const defSelection = useMemo(() => {
      return (
        chipConfigs?.[1]?.filterSelection?.map((item) => ({
          name: item.value,
        })) || []
      );
    }, [chipConfigs]);

    return (
      <>
        <div className="production-metric-filter">
          <div className="production-name-container">
            <AurSelectDropdown
              items={productionData}
              dataTestId="product-name-dropdown"
              searchPlaceHolder={t('userHomePage.search')}
              itemsCountwithNoScroll={3}
              itemDisplay="name"
              itemKey="name"
              selectAllLabel={t('common.selectAll')}
              selectAll={productionData?.length > 0 ? true : false}
              dropdownLabel={t(
                'reports.highLevelProductionMetrics.productionName'
              )}
              onSelectionChange={(data) => {
                trackGAEvent({
                  eventName: GA_EVENT_NAMES.FILTER,
                  click: {
                    name: t('gaTracking.reports.productionName'),
                    type: GA_CLICK_TYPES.DROPDOWN,
                    region: GA_REGIONS.BODY,
                    action: t('gaTracking.reports.filterReport'),
                  },
                });
                handleOnDropdownDataChanged(
                  1,
                  data?.map((item: any) => {
                    return {
                      value: item.name,
                    };
                  })
                );
              }}
              defaultSelection={defSelection}
              clearValues={productionName.length === 0}
              onClearClicked={() => onRemoveFilter(2)}
              hasValidationError={false}
              validationText=""
              helperText=""
              aria-label={t(
                'reports.highLevelProductionMetrics.productionName'
              )}
              search={productionData?.length > 11}
            />
          </div>

          <div className="datepicker-container">
            <Typography className="typo-text body2_size mist-color-400">
              {t('reports.highLevelProductionMetrics.selectDateRange')}
            </Typography>
            <div>
              {' '}
              <AurDateRangePicker
                startYearFromRange={50}
                onDateChange={handleOnDateChange}
                initialEndDate={convertDateStringToObject(endDate, true)}
                initialStartDate={convertDateStringToObject(startDate, true)}
                shouldShowApplyButton={true}
              />
            </div>
          </div>
        </div>
        {(chipConfigs[0]?.filterSelection?.length > 0 ||
          chipConfigs[1]?.filterSelection?.length > 0) && (
          <div className="chip-container">
            <AurChipList
              onResetToDefault={handleResetToDefault}
              onSave={handleOnSave}
              onClearAll={handleOnClearAll}
              hasFilterValueChanged={hasFilterValueChanged}
              chipConfigs={chipConfigs}
              isOnSaveLoading={isOnSaveFilterLoading}
              isClearAllLoading={isClearAllFilterLoading}
              trackFilter={true}
            />
          </div>
        )}
        <Box>
          <div className="highlevel-production-metric-table-container">
            <div
              ref={parentElementRef}
              className={`${!exportPdf ? 'pdf-export' : ''}`}
            >
              <AurDataGrid
                className="highlevel-production-metric-table"
                getRowId={(row) => row.id}
                columns={getHighLevelProductionMetricTableColumns()}
                rows={tableData}
                pageSizeOptions={TABLE_PAGE_SIZE_OPTION}
                visibleToolTip={true}
                checkBoxVisible={false}
                entityType={''}
                pointer={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                totalRowCount={paginationData?.totalItems}
                sortModel={sortModel}
                setSortModel={onSetSortModel}
                onPageChange={(page: number) => setCurrentPage(page)}
                onPageSizeChange={(newPageSize: number) =>
                  setItemsPerPage(newPageSize)
                }
                paginationMode="server"
                sortingMode="server"
                onRowClick={(params) => handleRowClick(params.row)}
                rowSelectionModel={selectedRows !== null ? [selectedRows] : []}
                onRefresh={() => fetchProductMetric()}
                containerHeight={size}
                noRowsOverlay={
                  isFetchProductionMetricLoading
                    ? AurDataGridLoadingOverlay //no data overlay
                    : isFailedToLoadProductionMetric
                      ? AurDataGridErrorOverlay //refresh
                      : undefined
                }
                enableRowClickOnEnterPress={true}
              />
              <Grid container className="production-metric-bottom">
                <Grid
                  item
                  direction="column"
                  container
                  className="production-container"
                >
                  <Grid item className="production-sets-container">
                    <Typography className="typo-text display1_size mist-color-100">
                      {numberFormatter(chartData.productionSets)}
                    </Typography>
                    <Typography className="typo-text subhead4_size mist-color-700">
                      {chartData?.productionSets > 1
                        ? t('reports.highLevelProductionMetrics.productionSets')
                        : t('reports.highLevelProductionMetrics.productionSet')}
                    </Typography>
                  </Grid>
                  <Grid item className="production-sets-container">
                    <Typography className="typo-text display3_size mist-color-100 bates-label">
                      {`${chartData?.firstBates ? chartData.firstBates : 'N/A'} - ${chartData?.lastBates ? chartData.lastBates : 'N/A'}`}
                    </Typography>
                    <Typography className="typo-text subhead4_size mist-color-700">
                      {t('reports.highLevelProductionMetrics.firstlastBates')}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid item className="chart-container">
                  <AurDocPiechart
                    data={data}
                    title={t('reports.highLevelProductionMetrics.chartTitle')}
                    backgroundColor={bgColor}
                    colors={colors}
                  />
                </Grid>
              </Grid>
            </div>
            {clearAllModal && (
              <AurPopup
                className="aur-unsaved-changes-popup"
                open={clearAllModal}
                onOk={handleClearAllModalOptionSelected}
                onCancel={closeModalHandler}
                popupHeading={t('common.clearAllPopup.clearHeading')}
                popupContent={t('common.clearAllPopup.popupContent')}
                popupTitle={t('common.clearAllPopup.popupTitle')}
                showPopupHeading={true}
                showPopupTitle={true}
                showCloseIcon={true}
                labelActionCancel={t('common.clearAllPopup.buttonCancel')}
                labelActionOk={t('common.clearAllPopup.buttonYes')}
                exitButtonHint={t('common.clearAllPopup.cacnelToClearHint')}
                continueButtonHint={t(
                  'common.clearAllPopup.confirmToClearHint'
                )}
                cancelButtonTitle=""
              />
            )}
            {resetToDefaultModal && (
              <AurPopup
                className="aur-unsaved-changes-popup"
                open={resetToDefaultModal}
                onOk={handleResetToDefaultModalOptionSelected}
                onCancel={closeModalHandler}
                popupHeading={t('common.clearAllPopup.ResetHeading')}
                popupContent={t('common.clearAllPopup.popupContent')}
                popupTitle={t('common.clearAllPopup.popupTitle')}
                showPopupHeading={true}
                showPopupTitle={true}
                showCloseIcon={true}
                labelActionCancel={t('common.clearAllPopup.buttonCancel')}
                labelActionOk={t('common.clearAllPopup.ResetYes')}
                cancelButtonTitle=""
                exitButtonHint={t(
                  'common.clearAllPopup.cancelResetToDefaultHint'
                )}
                continueButtonHint={t(
                  'common.clearAllPopup.confirmResetToDefaultHint'
                )}
              />
            )}
          </div>
        </Box>
        {
          <AurLoadingIndicator
            overlay={true}
            isOpen={
              isFetchProductionMetricLoading ||
              isFetchSavedFiltersLoading ||
              isFetchProductionDataLoading
            }
          />
        }
      </>
    );
  });

export default HighLevelProductionMetricTable;
